const Util = {};

/*
 * 空值处理 null undefine 等
 * */
Util.empty = function (str) {
  if (typeof str === "number") {
    return str;
  }
  if (!str) {
    return "";
  }
  return str;
};

/*
 * 解析url参数
 * @param {String} paras 参数名
 * @param {String} url 链接地址
 * @return {String} 或 {Object}
 * */
Util.getUrlParams = function (paras, url, place) {
  url = url || window.location.href;
  place = typeof place === "number" ? place : 1;
  url = url.split("#")[place].replace("/&", "&");
  const paraData = url.substring(url.indexOf("?") + 1, url.length).split("&");
  const paraObj = {};
  for (let i = 0, len = paraData.length; i < len; i++) {
    const j = paraData[i];
    paraObj[j.substring(0, j.indexOf("="))] = decodeURIComponent(
      j.substring(j.indexOf("=") + 1, j.length)
    );
  }
  if (!paras) {
    // 获取所有参数
    if (url.indexOf("?") >= 0) {
      return url.substring(url.indexOf("?") + 1, url.length);
    } else {
      return "";
    }
  }
  if (paras) {
    return paraObj[paras] ? paraObj[paras] : "";
  }
  return paraObj;
};

/*
 * 设置url参数
 * @param {String} url 链接地址
 * @param {String} key
 * @param {String} value
 * @return {String}
 * */
Util.setUrlParams = function (key, value, url) {
  if (typeof key === "object") {
    url = value || "";
    for (const i in key) {
      if (Object.prototype.hasOwnProperty.call(key, i)) {
        url = Util.setUrlParams(i, key[i], url);
      }
    }
    return url;
  }
  if (!key) {
    return url;
  }
  value = Util.empty(value);
  value = encodeURIComponent(value);
  url = url || window.location.href;
  const reg = new RegExp(`(\\?|\\&)${key}=`),
    reg2 = new RegExp(`((\\?|\\&)${key}=)[^&]+`);
  if (url.indexOf("?") >= 0) {
    url = reg.test(url)
      ? url.replace(reg2, `$1${value}`)
      : `${url}&${key}=${value}`;
  } else {
    url = `${url}?${key}=${value}`;
  }
  return url;
};

/*
 * 检测移动终端浏览器版本信息
 * @return {Object}
 * */
Util.mobile = function () {
  const u = navigator.userAgent;
  return {
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    trident: u.indexOf("Trident") > -1, // IE内核
    presto: u.indexOf("Presto") > -1, // opera内核
    webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
    gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或uc浏览器
    iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("iPad") > -1, // 是否iPad
    webApp: u.indexOf("Safari") == -1, // 是否web应该程序，没有头部与底部
    iosUp5: /OS [5-9]_\d[_\d]* like Mac OS X/i.test(u),
    wx: u.indexOf("MicroMessenger") > -1,
    wxApp: !!Util.getUrlParams("minilogin", 0, 0),
  };
};

/*
 * cookie的操作
 * */
Util.cookie = (function (doc) {
  /*
   * 获取cookie
   * @param {String} name cookie名称
   * */
  function get(name) {
    if (!name) return "";
    let result = "";
    const cookies = doc.cookie;
    if (cookies.length > 0) {
      let begin = cookies.indexOf(`${name}=`);
      if (begin != -1) {
        begin += name.length + 1; // cookie值的初始位置
        let end = cookies.indexOf(";", begin); // 结束位置
        if (end == -1) {
          end = cookies.length;
        } // 没有;则end为字符串结束位置
        result = cookies.substring(begin, end);
        result = result ? decodeURIComponent(result) : "";
      }
    }
    return result;
  }

  /*
   * 设置cookie
   * @param {String} name cookie名称
   * @param {String} value cookie值
   * @param {Date}或{Number} expire 过期时间 (日期对象或者为毫秒数)
   * @param {String} path cookie的路径
   * */
  function set(name, value, expire, path, domain) {
    if (!name) {
      return;
    }
    value = Util.empty(value);
    let expireDate = new Date();
    if (Object.prototype.toString.call(expire) === "[object Date]") {
      expireDate = expire;
    } else if (typeof expire === "number") {
      expireDate.setTime(expireDate.getTime() + expire);
    }
    doc.cookie = `${name}=${encodeURIComponent(value)}${
      typeof expire === "undefined" || expire == null
        ? ""
        : `; expires=${expireDate.toGMTString()}`
    };path=${path || "/"};domain=${domain}`;
  }

  /*
   * 删除cookie
   * @param {String} name cookie名称
   * @param {String} path cookie的路径
   * */
  function remove(name, path) {
    if (!name) return;
    set(name, "", -1, path, "gtarcade.com");
  }

  return {
    get,
    set,
    remove,
  };
})(document);

/*
 * localStorage 操作
 * @return {Object}
 * */
Util.ls = (function (window) {
  const ls = window.localStorage,
    isSupport = !!ls;
  /*
   * 获取 localStorage
   * @param {String} key
   * @return {String}
   * */
  function get(key) {
    if (!key) return;
    let result = "";
    if (isSupport) {
      result = ls.getItem(key);
      result = result ? decodeURIComponent(result) : "";
      try {
        // safari隐身浏览时
        ls.setItem("test", "test");
      } catch (e) {
        result = Util.cookie.get(key);
      }
    } else {
      result = Util.cookie.get(key);
    }
    return result;
  }

  /*
   * 设置 localStorage
   * @param {String} key
   * @param {String} value
   * */
  function set(key, value) {
    if (!key) {
      return;
    }
    value = encodeURIComponent(Util.empty(value));
    if (isSupport) {
      try {
        // safari隐身浏览时
        ls.setItem(key, value);
      } catch (e) {
        const expire = 3153600000000; // 100年
        Util.cookie.set(key, value, expire);
      }
    } else {
      const expire = 3153600000000; // 100年
      Util.cookie.set(key, value, expire);
    }
  }

  /*
   * 删除 localStorage
   * @param {String} key
   * */
  function remove(key) {
    if (!key) return;
    if (isSupport) {
      ls.removeItem(key);
      try {
        // safari隐身浏览时
        ls.setItem("test", "test");
      } catch (e) {
        Util.cookie.remove(key);
      }
    } else {
      Util.cookie.remove(key);
    }
  }
  return {
    get,
    set,
    remove,
  };
})(window, Util);

/*
 * sessionStorage 操作
 * @return {Object}
 * */

Util.ss = (function (window) {
  const ss = window.sessionStorage,
    isSupport = !!ss;
  /*
   * 获取 sessionStorage
   * @param {String} key
   * @return {String}
   * */
  function get(key) {
    if (!key) return;
    let result = "";
    if (isSupport) {
      result = ss.getItem(key);
      result = result ? decodeURIComponent(result) : "";
      try {
        // safari隐身浏览时
        ss.setItem("test", "test");
      } catch (e) {
        result = Util.cookie.get(key);
      }
    } else {
      result = Util.cookie.get(key);
    }
    return result;
  }

  /*
   * 设置 sessionStorage
   * @param {String} key
   * @param {String} value
   * */
  function set(key, value) {
    if (!key) {
      return;
    }
    value = encodeURIComponent(Util.empty(value));
    if (isSupport) {
      try {
        // safari隐身浏览时
        ss.setItem(key, value);
      } catch (e) {
        Util.cookie.set(key, value);
      }
    } else {
      Util.cookie.set(key, value);
    }
  }

  /*
   * 删除 sessionStorage
   * @param {String} key
   * */
  function remove(key) {
    if (!key) return;
    if (isSupport) {
      ss.removeItem(key);
      try {
        // safari隐身浏览时
        ss.setItem("test", "test");
      } catch (e) {
        Util.cookie.remove(key);
      }
    } else {
      Util.cookie.remove(key);
    }
  }
  return {
    get,
    set,
    remove,
  };
})(window, Util);

Util.dateParse = function (date, input, h24 = true) {
  if (!date) {
    return;
  }
  if (typeof date === "string") {
    date = new Date(date.replace(/-/g, "/"));
  } else if (typeof date === "number") {
    date = new Date(date);
  }
  input = input || "yyyy-MM-dd HH:mm:ss";
  const format = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": h24 ? date.getHours() : date.getHours() % 12, // 小时
    "H+": h24 ? date.getHours() : date.getHours() % 12, // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  const week = {
    0: "7",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
  };
  if (/(y+)/.test(input)) {
    input = input.replace(
      RegExp.$1,
      `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
    );
  }
  if (/(E+)/.test(input)) {
    input = input.replace(RegExp.$1, week[`${date.getDay()}`]);
  }
  for (const k in format) {
    if (new RegExp(`(${k})`).test(input)) {
      input = input.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? format[k]
          : `00${format[k]}`.substr(`${format[k]}`.length)
      );
    }
  }
  return input;
};

Util.dateRange = function ({
  type,
  nowDate = new Date(),
  formatDate = "yyyy/MM/dd",
  getDate = false,
}) {
  // 处理快速筛选时间 type为number时：type天前 '1'：本月 '2'：上月  getDate: 单个日期 默认 否
  const dateParse = Util.dateParse;
  if (typeof getDate != "boolean") {
    console.warn("getDate参数类型不为Boolean，请检查传入的参数类型");
    return;
  }

  let endTime,
    startTime,
    myDate = new Date(nowDate);

  if (typeof type === "number") {
    if (type == 30) {
      let thisMonth = myDate.getMonth(),
        thisYear = myDate.getFullYear();
      myDate = new Date(myDate.setFullYear(thisYear, thisMonth, 1));
      myDate = new Date(myDate.setDate(myDate.getDate() - 1)); // 上月最后一天
      endTime = dateParse(myDate, formatDate);
      // 重新获取日期
      thisMonth = myDate.getMonth();
      thisYear = myDate.getFullYear();
      myDate = myDate.setFullYear(thisYear, thisMonth, 1); // 上月第一天
      startTime = dateParse(myDate, formatDate);
    } else {
      endTime = dateParse(myDate, formatDate);
      myDate = myDate.setDate(myDate.getDate() - type);
      startTime = dateParse(myDate, formatDate);
    }
  }
  if (getDate) {
    return startTime;
  } else {
    return [startTime, endTime];
  }
};

Util.valueHandler = function (value) {
  // 处理数字如果超过五位数单位变为万
  if (typeof value === "string") {
    value = value - 0;
  }
  if (Math.abs(value) >= 10000) {
    // 超过1万
    value = Math.floor(value / 1000) / 10 + "<span>万</span>";
  } else {
    value = Math.floor(value * 10) / 10;
  }
  return value;
};

Util.trim = function (value) {
  value = value.toString();
  let reg = new RegExp(/(^\s*)|(\s*$)/g);
  return value.replace(reg, "");
};

Util.throttling = function (fn, wait = 1000, immediate = false) {
  let timer,
    timeStamp = 0;
  let context, args;

  let run = () => {
    timer = setTimeout(() => {
      if (!immediate) {
        fn.apply(context, args);
      }
      clearTimeout(timer);
      timer = null;
    }, wait);
  };

  return function (...arg) {
    context = this;
    args = arguments || arg;
    if (!timer) {
      if (immediate) {
        fn.apply(context, args);
      }
      run();
    } else {
      // console.log("throttle, ignore");
    }
  };
};

Util.debounce = function (fn, wait = 1000, immediate = false) {
  let timer,
    startTimeStamp = 0;
  let context, args;

  let run = (timerInterval) => {
    timer = setTimeout(() => {
      let now = new Date().getTime();
      let interval = now - startTimeStamp;
      if (interval < timerInterval) {
        startTimeStamp = now;
        run(wait - interval);
      } else {
        if (!immediate) {
          fn.apply(context, args);
        }
        clearTimeout(timer);
        timer = null;
      }
    }, timerInterval);
  };

  return function (...arg) {
    context = this;
    args = arguments || arg;
    let now = new Date().getTime();
    startTimeStamp = now;

    if (!timer) {
      if (immediate) {
        fn.apply(context, args);
      }
      run(wait);
    }
  };
};

Util.generatorCheckType = function (type) {
  type = type.toLowerCase();
  return function (target) {
    return (
      Object.prototype.toString.call(target).toLowerCase() ===
      `[object ${type}]`
    );
  };
};

Util.rem2px = function (val) {
  var fs = parseFloat(document.documentElement.style.fontSize);
  return val * fs;
};
Util.px2rem = function (val) {
  var fs = parseFloat(document.documentElement.style.fontSize);
  return val / fs;
};
Util.sleep = function (time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), time);
  });
};

// 获取字符串长度
Util.byteLength = function (str) {
  // Force string type
  str = String(str);

  var byteLen = 0;
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    var len =
      (c & 0xf800) == 0xd800
        ? 2 // Code point is half of a surrogate pair
        : c < 1 << 7
        ? 1
        : c < 1 << 11
        ? 2
        : 3;
    byteLen += len == 3 ? 2 : len;
  }
  return byteLen;
};

// 判断当前环境是app内嵌，还是微端
Util.pageUserAgent = (function () {
  let pageUserAgent = /com\.gtarcade\.osapp/.test(navigator.userAgent)
    ? "app"
    : /gtarcade/.test(navigator.userAgent)
    ? "client"
    : "browser";
  return pageUserAgent;
})();

Util.random = function (max, min = 0) {
  if (max == min) {
    console.error("随机值的max与min相等无意义！");
  }
  return Math.round(Math.random() * (max - min) + min);
};

export default Util;
export const {
  empty,
  getUrlParams,
  setUrlParams,
  mobile,
  cookie,
  ls,
  ss,
  dateParse,
  dateRange,
  valueHandler,
  trim,
  throttling,
  debounce,
  generatorCheckType,
  rem2px,
  px2rem,
  sleep,
  pageUserAgent,
  byteLength,
  random,
} = Util;
